import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kzhlwqtntbxoraidpedd.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt6aGx3cXRudGJ4b3JhaWRwZWRkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIxMTI5NTQsImV4cCI6MjA5NzY4ODk1NH0.8737kcY9mdMf0LyS6i6zJsPFjJBpC1rc5PYwGZx2nic';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
